// Function to set a key-value pair in localStorage
export function setLocalStorageItem(key, value) {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error("Error setting localStorage item:", error);
    }
  }
}

// Function to get a value from localStorage by key
export function getLocalStorageItem(key) {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      return key ? localStorage.getItem(key) : "";
    } catch (error) {
      console.error("Error getting localStorage item:", error);
      return "";
    }
  }
}

// Function to remove value from localStorage by key
export function removeLocalStorageItem(key) {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing localStorage item:", error);
    }
  }
}
